import React, { useCallback, useMemo, useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Container } from '@material-ui/core'

import NavbarLeft from './NavbarLeft'
import UserNotification from './UserNotification'
import UserProfile from './UserProfile'
import IdeaChallengePopup from '../IdeachallengePopup/IdeaChallengePopup'
import ChallengePopup from '../challengePopup/ChallengePopup'
import NavigationService from '../../support/navigation/NavigationService'

import styles from './View.Style'
import { getNavbarItems, getNavbarPaths } from './navbarHelpers'
import useIdeaChallengeModal from './hook/useIdeaChallengeModal'

const Navbar = (props) => {
  const {
    classes,
    logoUrl,
    onLogoClick,
    domains,
    navigateToDomain,
    whiteListDomainLoading,
    whiteListDomainService,
    userLoginEmail,
    notifications,
    markNotificationsRead,
    userName,
    userBalance,
    userPhoto,
    showAdmin,
    isAdmin,
    isInnovator,
    isHackathonEnable,
    listInnovateChallenge,
    listInnovateChallengeLoading,
    getInnovateChallengeFilterListFn,
    getActiveChallenges,
    challengesList,
    filterListInnovateChallengeTotal,
    currentDomain
  } = props

  const [openMenu, setOpenMenu] = useState(false)
  const [showChallengeModal, setShowChallengeModal] = useState(false)

  // const paths = useMemo(() => getNavbarPaths(), [])
const paths = useMemo(() => {
  NavigationService.setDomain(currentDomain);
  return getNavbarPaths();
}, [currentDomain]);

  const navbarItems = useMemo(
    () =>
      getNavbarItems({
        paths,
        isAdmin,
        isInnovator,
        isHackathonEnable,
      }),
    [paths, isAdmin, isInnovator, isHackathonEnable]
  )

  const {
    showIdeaChallengeModal,
    challengeListData,
    openIdeaModal,
    closeIdeaModal,
    loadMoreChallenges,
  } = useIdeaChallengeModal({
    isHackathonEnable,
    listInnovateChallenge,
    getInnovateChallengeFilterListFn,
    getActiveChallenges,
  })

  const toggleMenu = useCallback(() => {
    setOpenMenu((prev) => !prev)
  }, [])

  const closeMenu = useCallback(() => {
    setOpenMenu(false)
  }, [])

  const openChallengeModal = useCallback(() => {
    setShowChallengeModal(true)
  }, [])

  const closeChallengeModal = useCallback(() => {
    setShowChallengeModal(false)
  }, [])

  const handleDomainChange = useCallback(
    (event) => {
      whiteListDomainService(userLoginEmail, event.target.value)
    },
    [whiteListDomainService, userLoginEmail]
  )

  const popupChallengesList = useMemo(() => {
    const list = isHackathonEnable ? challengeListData : challengesList;

    return Array.from(
      new Map(list.map(item => [item.id, item])).values()
    );
  }, [isHackathonEnable, challengeListData, challengesList]);

  return (
    <>
      <nav className={classes.navsec}>
        <Container maxWidth={false}>
          <div className={classes.menuSection}>

            {/* ✅ LEFT */}
            <NavbarLeft
              classes={classes}
              openMenu={openMenu}
              toggleMenu={toggleMenu}
              closeMenu={closeMenu}
              logoUrl={logoUrl}
              onLogoClick={onLogoClick}
              domains={domains}
              navigateToDomain={navigateToDomain}
              navbarItems={navbarItems}
              handleDomainChange={handleDomainChange}
              whiteListDomainLoading={whiteListDomainLoading}
              openChallengeModal={openChallengeModal}
              isHackathonEnable={isHackathonEnable}
            />

            {/* ✅ RIGHT */}
            <div className={classes.rightNestedNavContainer}>
              <button
                type="button"
                onClick={openIdeaModal}
                className={classes.postIdea}
                disabled={listInnovateChallengeLoading}
              >
                Post an Idea
              </button>

              {showIdeaChallengeModal && (
                <IdeaChallengePopup
                  filterListInnovateChallengeTotal={
                    filterListInnovateChallengeTotal
                  }
                  listInnovateChallengeLoading={
                    listInnovateChallengeLoading
                  }
                  enableIsHackathon={isHackathonEnable}
                  onClickLoadMore={loadMoreChallenges}
                  onClose={closeIdeaModal}
                  challengesList={popupChallengesList}
                  isAdmin={isAdmin}
                />
              )}

              <div className={classes.profilePicHolder}>
                {!isHackathonEnable && (
                  <UserNotification
                    notifications={notifications}
                    markNotificationsRead={markNotificationsRead}
                    classes={classes}
                  />
                )}

                <UserProfile
                  userName={userName}
                  userBalance={userBalance}
                  userPhoto={userPhoto}
                  showAdmin={showAdmin}
                  classes={classes}
                />
              </div>
            </div>
          </div>
        </Container>
      </nav>

      {/* ✅ ✅ IMPORTANT: POPUP OUTSIDE */}
      {showChallengeModal && (
        <ChallengePopup onClose={closeChallengeModal} />
      )}

      <div className={classes.navDummyFill} />
    </>
  )
}

export default withStyles(styles)(Navbar)